//
// client-exceptions.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').controller('ClientExceptionsController', ['$scope', 'ClientExceptionsService',
       'CLIENT_EXCEPTIONS_UTILS',

       ($scope, ClientExceptionsService, CLIENT_EXCEPTIONS_UTILS) => {
            // Scope bound functions and variables
           $scope.model = {
               viewName: CLIENT_EXCEPTIONS_UTILS.viewNames[CLIENT_EXCEPTIONS_UTILS.getPageParams().view].name,
               pageParams: CLIENT_EXCEPTIONS_UTILS.getPageParams(),
               summary: {
                   sortBy: 'lastOccurrence',
                   sortReverse: true,
                   filterBy: null,
                   data: null,
                   total: 0,
                   perPage: 100,
                   currentPage: 1,
               },
               details: {
                   sortBy: 'timestamp',
                   sortReverse: true,
                   filterBy: null,
                   data: null,
                   total: 0,
                   perPage: 100,
                   currentPage: 1,
                   currentStackTrace: null,
                   currentException: null,
               },
               outstandingRequest: false,
           };

           const fetchExceptionSummary = () => {
               changeOutstandingRequestStatus(true);
               ClientExceptionsService.getExceptionSummary(
                    $scope.model.pageParams.start,
                    $scope.model.pageParams.end
                    ).then(data => {
                        $scope.model.summary.data = data;
                    }, err => {
                        alert(err);
                    }).finally(() => {
                        changeOutstandingRequestStatus(false);
                    });
           };

           const fetchExceptionDetails = () => {
               changeOutstandingRequestStatus(true);
               ClientExceptionsService.getExceptionDetails($scope.model.pageParams.type,
                        $scope.model.pageParams.start,
                        $scope.model.pageParams.end,
                        $scope.model.pageParams.page,
                        $scope.model.pageParams.sortBy,
                        $scope.model.pageParams.sortReverse,
                        $scope.model.pageParams.filter
                        ).then(results => {
                            $scope.model.details.data = results.data;
                            $scope.model.details.total = results.total;
                        }, err => {
                            alert(err);
                        }).finally(() => {
                            changeOutstandingRequestStatus(false);
                        });
           };

            // This method is used to change the value of $scope.model.outstandingRequest
            // In order to prevent the loading indicator from constantly popping in and
            // out, we'll wait 500ms before setting 'outstandingRequest' to false. If the
            // value is subsequently changed to 'true', we'll clear the request to
            // make the value 'false'.
           const changeOutstandingRequestStatus = outstandingRequestExists => {
               if (outstandingRequestExists) {
                   clearTimeout($scope.model.outstandingRequestTimeout);
                   $scope.model.outstandingRequest = outstandingRequestExists;
               } else {
                   $scope.model.outstandingRequestTimeout = setTimeout(() => {
                       $scope.$apply(() => {
                           $scope.model.outstandingRequest = outstandingRequestExists;
                       });
                   }, 500);
               }
           };

           const initPage = () => {
               if ($scope.model.pageParams.view === 'summary') {
                   CLIENT_EXCEPTIONS_UTILS.setPageParam(null);
                   CLIENT_EXCEPTIONS_UTILS.setFilterParam(null);
                   CLIENT_EXCEPTIONS_UTILS.setSortByParam(null, null);

                   fetchExceptionSummary();
               } else if ($scope.model.pageParams.view === 'details') {
                   if (!$scope.model.pageParams.page) {
                       CLIENT_EXCEPTIONS_UTILS.setPageParam(1);
                   }
                   if (!$scope.model.pageParams.sortBy) {
                       CLIENT_EXCEPTIONS_UTILS.setSortByParam('timestamp', true);
                   }

                   fetchExceptionDetails();
               }
           };

           $scope.model.setView = view => {
               CLIENT_EXCEPTIONS_UTILS.setViewParam(view);
           };

           $scope.model.updateDateParams = $event => {
                // Keyboard event, 13 = Enter so this will only fire if the user hits "enter" after updating the field.
               if ($event.which === 13) {
                   CLIENT_EXCEPTIONS_UTILS.setDateParam($scope.model.pageParams.start, $scope.model.pageParams.end);
               }
           };

           $scope.model.updateFilterParam = $event => {
                // Keyboard event, 13 = Enter so this will only fire if the user hits "enter" after updating the field.
               if ($event.which === 13) {
                   CLIENT_EXCEPTIONS_UTILS.setFilterParam($event.currentTarget.value);
               }
           };

           $scope.model.displayExceptionDetails = type => {
               CLIENT_EXCEPTIONS_UTILS.setTypeParam(type);
               fetchExceptionDetails();
               CLIENT_EXCEPTIONS_UTILS.setViewParam('details');
           };

           $scope.model.displayExceptionSummary = () => {
               CLIENT_EXCEPTIONS_UTILS.setTypeParam(null);
               fetchExceptionSummary();
               CLIENT_EXCEPTIONS_UTILS.setViewParam('summary');
           };

           $scope.model.displayExceptionStackTrace = (exception, exceptionStackTrace) => {
               $scope.model.details.currentException = exception;
               $scope.model.details.currentStackTrace = exceptionStackTrace;
               $('#stackTraceModal').modal('show');
           };

           $scope.model.closeExceptionStackTraceModal = () => {
               $('#stackTraceModal').modal('hide');
               $scope.model.details.currentException = null;
               $scope.model.details.currentStackTrace = null;
           };

           $scope.model.setSortBy = (sortBy, sortReverse) => {
               CLIENT_EXCEPTIONS_UTILS.setSortByParam(sortBy, sortReverse);
               fetchExceptionDetails();
           };

           $scope.relativeTime = datetime => moment(datetime).from(DateTimeService.userNow());

           $scope.fetchExceptionDetailsPage = page => {
               CLIENT_EXCEPTIONS_UTILS.setPageParam(page);
               fetchExceptionDetails();
           };

            // Page initialization
           initPage();
       },
        ]);
}))();
